<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modal"
      centered
      size="lg"
      title="เอกสารมัดจำ"
      hide-footer
      footer-class="pt-0 border-0"
    >
      <b-row>
        <b-col>
          <InputText
            v-model="filter.invoice_no"
            textFloat="Doc Number / เลขที่เอกสาร"
            placeholder="Doc Number / เลขที่เอกสาร"
            type="text"
            name="doc_number"
            @onDataChange="handleSearch"
            class="mb-2"
          />
        </b-col>
        <b-col>
          <InputText
            v-model="filter.search"
            textFloat="Customer name / ชื่อลูกค้า"
            placeholder="Customer name / ชื่อลูกค้า"
            type="text"
            name="inventory_search"
            @onDataChange="handleSearch"
            class="mb-2"
          />
        </b-col>

        <b-col cols="12">
          <b-table
            responsive
            striped
            hover
            :fields="fields"
            :items="items"
            :busy="isBusy"
            show-empty
            empty-text="No matching records found"
            class="table-main oveflow-auto table-custom"
            :no-border-collapse="false"
          >
            <template v-slot:cell(id)="data">
              <b-button
                variant="primary-color"
                class="btn-modal btn-hover"
                @click="handleBilling(data.item.id)"
              >
                เลือก
              </b-button>
            </template>
            <template v-slot:cell(customer_name)="{ item }">
              {{ item.firstNameTh + " " + item.lastNameTh }}
              <div>
                <small>{{ item.member_id }}</small>
              </div>
              <div>
                <small>{{ item.is_company ? "Company" : "Personal" }}</small>
              </div>
            </template>
            <template v-slot:cell(record_created_time)="data">
              <div
                v-if="data.item.record_created_time != '0001-01-01T00:00:00'"
              >
                {{
                  $moment(data.item.record_created_time)
                    .add(543, "years")
                    .format($formatDateNewFull)
                }}
              </div>
              <div v-else>-</div>
            </template>
            <template v-slot:cell(deposit_price)="data">
              {{ data.item.deposit_price | numeral("0,0.00") }}
            </template>
            <template v-slot:cell(credit_balance)="data">
              {{ data.item.credit_balance | numeral("0,0.00") }}
            </template>
            <template v-slot:cell(action)="data">
              <font-awesome-icon
                icon="trash-alt"
                class="pointer"
                @click="removeItems(data.item.id)"
              ></font-awesome-icon>
            </template>
            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <Pagination
        page="page"
        @handleChangeTake="handleChangeTake"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
      />
    </b-modal>
    <b-modal
      v-model="depositPriceModal"
      ref="modal"
      centered
      size="sm"
      hide-header
      hide-footer
      footer-class="pt-0 border-0"
    >
      <div style="width: 80%; margin: auto">
        <b-form-group label="" v-slot="{ ariaDescribedby }">
          <b-form-radio
            v-model="selectPrice"
            :aria-describedby="ariaDescribedby"
            name="some-radios"
            :value="1"
            class="custom-radio"
            ><div
              class="d-flex align-items-center justify-content-between w-100"
            >
              ราคาปัจจุบัน
              <span
                >{{
                  (depositPrice.currentResult.price.price +
                    depositPrice.currentResult.price.discount)
                    | numeral("0,0.00")
                }}
              </span>
            </div>
          </b-form-radio>
          <b-form-radio
            class="mt-3 custom-radio"
            v-model="selectPrice"
            :aria-describedby="ariaDescribedby"
            name="some-radios"
            :value="2"
            ><div
              class="d-flex align-items-center justify-content-between w-100"
            >
              ราคา ณ วันที่จอง
              <span>{{
                (depositPrice.oldResult.price.price +
                  depositPrice.oldResult.price.discount)
                  | numeral("0,0.00")
              }}</span>
            </div>
          </b-form-radio>
        </b-form-group>
      </div>
      <b-row class="align-items-center justify-content-center">
        <b-col cols="4"
          ><b-button
            variant="custom-outline-primary"
            @click="depositPriceModal = false"
          >
            ยกเลิก</b-button
          ></b-col
        >
        <b-col cols="auto"
          ><b-button @click="submit"> ส่งไปสร้างรายการขาย</b-button></b-col
        >
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import OtherLoading from "@/components/loading/OtherLoading";
import { mapGetters } from "vuex";
export default {
  props: {
    paymentChannelList: {
      require: true,
      type: Array,
    },
    isFullPos: {
      require: false,
      type: [Number, String],
    },
  },
  components: {
    OtherLoading,
    Pagination,
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  data() {
    return {
      depositPriceModal: false,
      filter: {
        page: 1,
        take: 5,
        search: "",
        invoice_no: "",
      },
      rows: 0,
      items: [],
      isBusy: false,
      showModal: false,
      fields: [
        {
          key: "id",
          label: "",
        },
        {
          key: "invoiceNo",
          label: "เลขใบมัดจำ",
          class: "text-center",
        },
        {
          key: "customer_name",
          label: "ชื่อลูกค้า",
          thClass: "text-center",
          tdClass: "text-left",
        },
        {
          key: "deposit_price",
          label: "เงินมัดจำ",
        },
        {
          key: "credit_balance",
          label: "เครดิตคงเหลือ",
        },
      ],
      depositPrice: {},
      selectPrice: 1,
    };
  },
  methods: {
    async getBillHolding() {
      this.isBusy = true;
      const res = await this.$axios(
        `${this.$baseUrl}/deposit/list?search=${this.filter.search}&BranchId=${this.branchId}&InvoiceNumber=${this.filter.invoice_no}&page=${this.filter.page}&pageSize=${this.filter.take}&DepositType=3`
      );
      this.isBusy = false;
      this.items = res.detail.transactionList;
      this.rows = res.detail.total;
    },
    async show() {
      this.getBillHolding();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
      this.selectPrice = 1;
    },
    async handleBilling(id) {
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.$axios(
        `${this.$baseUrl}/deposit/deposit_calculate/${id}`
      );
      await this.$store.dispatch("setMainLoading", false);
      this.depositPrice = { ...res.detail, deposit_id: id };
      this.selectPrice = 1;
      this.depositPriceModal = true;
    },
    handleChangeTake(val) {
      this.filter.take = val;
      this.filter.page = 1;
      this.getBillHolding();
    },
    handleSearch(value) {
      this.pagination(1);
    },
    pagination(val) {
      this.filter.page = val;
      this.getBillHolding();
    },
    async callRemoveItems(id) {
      const res = await this.$axios.delete(
        `${this.$baseUrl}/transaction/delete_hold_transaction/${id}`,
        this.filter
      );
      return res;
    },
    async removeItems(id) {
      this.confirmAlert().then(async ({ isConfirmed }) => {
        if (!isConfirmed) return;
        const res = await this.callRemoveItems(id);
        if (res.result) this.getBillHolding();
        else this.errorAlert(res.message);
      });
    },
    submit() {
      if (this.selectPrice == 1) {
        let payload = this.depositPrice.currentResult;
        this.$emit("loadBill", {
          ...payload,
          user_guid: this.depositPrice.user_guid,
          deposit_id: this.depositPrice.deposit_id,
        });
      } else {
        let payload = this.depositPrice.oldResult;
        this.$emit("loadBill", {
          ...payload,
          user_guid: this.depositPrice.user_guid,
          deposit_id: this.depositPrice.deposit_id,
        });
      }
      this.depositPriceModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .custom-radio .custom-control-label {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
